import { NavLink } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { BrandMark } from './Brand.js';
import { Icon, type IconName } from './Icon.js';
import { api } from '../lib/api.js';
import { getRefreshToken, clearSession } from '../lib/auth.js';

// Five items, flat and calm — one obvious destination each. Every old feature stays reachable via
// these hubs (reports tabs, sessions tabs, settings sections) and old URLs redirect (see App.tsx).
const NAV: { to: string; label: string; icon: IconName }[] = [
  { to: '/', label: 'בית', icon: 'dashboard' },
  { to: '/composer', label: 'שלח הודעה', icon: 'composer' },
  { to: '/reports', label: 'דוחות', icon: 'analytics' },
  { to: '/stats', label: 'סטטיסטיקה', icon: 'eye' },
  { to: '/sessions', label: 'המספרים והקבוצות', icon: 'sessions' },
  { to: '/settings', label: 'הגדרות', icon: 'settings' },
];

const ROLE_LABEL: Record<string, string> = { owner: 'בעלים · מנהל', admin: 'מנהל', agent: 'סוכן' };

export function Sidebar(): JSX.Element {
  // /auth/me resolves the current user (in dev the API stub answers without a token). Used only to
  // greet by name in the footer — never the security boundary (the API is).
  const { data: me } = useQuery({ queryKey: ['me'], queryFn: () => api.me() });
  const role = me?.user.role;

  async function logout(): Promise<void> {
    await api.logout(getRefreshToken());
    clearSession();
    window.location.assign('/login');
  }

  return (
    <aside className="side">
      <div className="brand">
        <BrandMark />
        <div className="wm">Cross<b>Castr</b></div>
      </div>
      <nav className="nav">
        {NAV.map((item) => (
          <NavLink key={item.to} to={item.to} end={item.to === '/'} className={({ isActive }) => (isActive ? 'active' : '')}>
            <Icon name={item.icon} /> {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="side-foot">
        <div className="av">{((me?.user.name || me?.user.email || me?.tenant.name || '·').trim() || '·').slice(0, 2)}</div>
        <div className="who">
          {me?.user.name || me?.user.email || me?.tenant.name || ''}<br />
          <small>{role ? ROLE_LABEL[role] ?? role : ''}</small>
        </div>
        <button className="btn ghost" onClick={logout} title="התנתק" style={{ marginInlineStart: 'auto', padding: '6px 10px' }}>
          <Icon name="close" />
        </button>
      </div>
    </aside>
  );
}
